<template>
    <div class="returngoods_content">
        <div class="orderdetails_table_content pad0">
            <Table
                border
                ref="selection"
                :columns="thead"
                :data="goodslist"></Table>
        </div>
        <div class="orderdetails_orderprice">
            <!-- <ul>
                <li><span>商品金额：</span><small>{{orderinfo.goodscost}}</small></li>
                <li><span>税费：</span><small>+{{orderinfo.tax_cost}}</small></li>
                <li><span>运费：</span><small>+{{orderinfo.shopps}}</small></li>
            </ul>
            <span>订单金额：</span><small>{{orderinfo.allcost}}元</small> -->
            <!-- <span>订单金额：</span><small>{{orderinfo.goodscost}}元</small> -->
            <span>订单金额：</span><small>{{returngoodscost}}元</small>
        </div>
        <div class="returngoods_box">
            <div class="returngoods_remarks">
                <span>备注：</span>
                <Input type="textarea" v-model="returnremarks" :rows="4" placeholder="请输入备注信息" />
            </div>
            <div class="returngoods_btn">
                <Button type="warning" @click="confirmbtn">确定</Button>
                <Button @click="cancelbtn">取消</Button>
            </div>
        </div>
        <!-- 编辑备注 -->
        <Remarks :remarksShow="remarksShow" :remarksInfo="remarksInfo" @remarksOk="remarksOk" @remarksCancel="remarksCancel"></Remarks>
    </div>
</template>

<script>
import api from '@/request/api.js'
import Remarks from '@/components/component/popup/remarks.vue'
import {toMoney} from '@/filter/moneyFilter.js'
export default {
    components: {Remarks},
    data() {
        return {
            remarksShow: false, // 备注编辑弹窗是否显示
            remarksInfo: '', // 备注编辑弹窗内容
            orderinfo: {}, // 订单信息
            returngoodscost: '0.00', // 退货金额
            thead: [ // 表格头部
                {
                    type: 'index',
                    width: 40,
                    align: 'center',
                },
                {
                    width: 260,
                    align: 'center',
                    title: '商品',
                    key: 'goods',
                    render: (h, params) => {
                        return h('div', // 商品
                                    [
                                        h('div', // 商品图片
                                            {
                                                class: 'shoppingcart_goods_left',
                                                style: {
                                                    backgroundImage: 'url(' + params.row.goodsimg + ')'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.goto(params.row.goodsid)
                                                    }
                                                }
                                            }
                                        ),
                                        h('div', // 商品右侧信息
                                            {
                                                class: 'shoppingcart_goods_right'
                                            },
                                            [   
                                                h('Poptip',
                                                    {
                                                        props: {
                                                            trigger: 'hover',
                                                            width: '246',
                                                            wordWrap: true,
                                                            content: params.row.goodsname
                                                        }
                                                    },
                                                    [
                                                        h('span', // 商品名称
                                                            {
                                                                class: 'shoppingcart_goods_name'
                                                            },
                                                            [
                                                                h('b',
                                                                    {
                                                                        style: {
                                                                            backgroundColor: params.row.cxtype == 1 ? '#FF8000' : '#40a250',
                                                                            display: params.row.cxtype == 1 || params.row.cxtype == 2 ? 'inline' : 'none'
                                                                        }
                                                                    },
                                                                    params.row.cxtype == 1 ? '特价' : (params.row.cxtype == 2 ? '折扣' : '')
                                                                ),
                                                                h('b', 
                                                                    {
                                                                        style: {
                                                                            backgroundColor: params.row.is_send == 1 ? '#FF8000' : '',
                                                                            display: params.row.is_send == 1 ? 'inline' : 'none'
                                                                        }
                                                                    },
                                                                    params.row.is_send == 1 ? '赠品' : ''
                                                                ),
                                                                h('span', params.row.goodsname)
                                                            ],
                                                        ),
                                                    ]
                                                ),
                                                h('small', // 商品编号
                                                    '商品编号：' + params.row.commcode
                                                )
                                            ]
                                        ),
                                    ]
                                )
                    }
                },
                {
                    align: 'center',
                    title: '规格',
                    key: 'gg_attrname'
                },
                {
                    align: 'center',
                    title: '单位',
                    key: 'unit',
                    render: (h, params) => {
                        if (params.row.doubleunit == 1) {
                            return h('span', params.row.unit)
                        }
                        if (params.row.doubleunit == 2) {
                            return h('div', {class: 'orderdetailunit'},
                                        [
                                            h('span', params.row.unit),
                                            h('small', '1' + params.row.maxunit + ' = ' + params.row.matrixing + params.row.unit),
                                        ]
                                    )
                        }
                    }
                },
                {
                    align: 'center',
                    title: '发货数量',
                    key: 'sendcount'
                },
                {
                    align: 'center',
                    title: '已退货',
                    key: 'rebacknum'
                },
                {
                    align: 'center',
                    title: '辅助数量',
                    key: 'fzshu',
                    render: (h, params) => {
                        return h('span', params.row.doubleunit == 2 ? (params.row.fzshu + params.row.maxunit + params.row.yushu + params.row.unit) : (params.row.yushu + params.row.unit))
                    }
                },
                {
                    align: 'center',
                    title: '数量',
                    key: 'num',
                    render: (h, params) => {
                        if (parseInt(params.row.sendcount) - parseInt(params.row.rebacknum) <= 0) {
                            return h('span', {style: {color: '#999'}}, '已退完')
                        }
                        if (parseInt(params.row.sendcount) - parseInt(params.row.rebacknum) > 0) {
                            return h('div', {class: "shoppingcart_num_content"},
                                        [
                                            h('div', {class: "shoppingcart_num_box"},
                                                [
                                                    h('div', {class: 'goods_list_num'},
                                                        [
                                                            h('span', 
                                                                {
                                                                    on: {
                                                                        click: () => {
                                                                            this.minBtn(params.row.num, params.row.rebacknum, params.index)
                                                                        }
                                                                    }
                                                                },
                                                                '-'
                                                            ),
                                                            h('InputNumber', {
                                                                    class: "goodsnum",
                                                                    props: {
                                                                        value: params.row.num
                                                                    },
                                                                    on: {
                                                                        'on-change': (e) => {
                                                                            params.row.num = e
                                                                        },
                                                                        'on-blur': () => {
                                                                            console.log(params.row.num)
                                                                            this.numBlur(params.row.num, params.row.sendcount, params.row.rebacknum, params.index)
                                                                        }
                                                                    }
                                                                }
                                                            ),
                                                            h('span', 
                                                                {
                                                                    on: {
                                                                        click: () => {
                                                                            this.addBtn(params.row.num, params.row.sendcount, params.row.rebacknum, params.index)
                                                                        }
                                                                    }
                                                                },
                                                                '+'
                                                            ),
                                                        ]
                                                    )
                                                ]
                                            )
                                        ]
                                    )
                        }
                    }
                },
                {
                    align: 'center',
                    title: '单价',
                    key: 'goodscost',
                    render: (h, params) => {
                        if (params.row.is_send == 1) return h('del', params.row.goodscost)
                        if (params.row.is_send == 0) return h('span', params.row.goodscost)
                    }
                },
                {
                    align: 'center',
                    title: '小计',
                    key: 'subtotal',
                    render: (h, params) => {
                        if (params.row.is_send == 1) return h('span', '0.00')
                        if (params.row.is_send == 0) return h('span', (params.row.num * params.row.goodscost).toFixed(2))
                    }
                },
                {
                    align: 'center',
                    title: '备注',
                    key: 'remarks',
                    render: (h, params) => {
                        if (params.row.ordergoodscontent == '') {
                            return h('Button', {
                                            props: {
                                                type: 'text'
                                            },
                                            style: {
                                                fontSize: '16px',
                                                color: '#0C1F6D',
                                                textDecoration: 'underline'
                                            },
                                            on: {
                                                click: () => {
                                                    this.edit(params.row.ordergoodscontent, params.index)
                                                }
                                            }
                                        },
                                        '编辑'
                                    )
                        }
                        if (params.row.ordergoodscontent != '') {
                            return h('Poptip',
                                        {
                                            props: {
                                                trigger: 'hover',
                                                content: params.row.ordergoodscontent,
                                                width: '170',
                                                wordWrap: true
                                            }
                                        },
                                        [
                                            h('span',
                                                {
                                                    class: 'shoppingcart_goods_remarks',
                                                    on: {
                                                        click: () => {
                                                            this.edit(params.row.ordergoodscontent, params.index)
                                                        }
                                                    }
                                                },
                                                params.row.ordergoodscontent
                                            )
                                        ],
                                    )
                        }
                    }
                },
            ],
            goodslist: [], // 表格列表
            returnremarks: '', // 订单备注
            ggids: '', // 商品规格id集
            ordernums: '', // 商品数量集
            goodscosts: '', // 商品单价集
            ordergoodscontents: '', // 商品备注集
            issend: '', // 商品是否为赠品集
            cxtype: '', // 商品促销集
        }
    },
    methods: {
        getInfo () { // 获取信息
            this.http.post(api.getreturngoods, {id: this.$route.params.id})
            .then(response => {
                console.log(response.data.msg)
                console.log(response.data.msg.marketorder_oneorder.det)
                for (var i = 0; i < response.data.msg.marketorder_oneorder.det.length; i++) {
                    response.data.msg.marketorder_oneorder.det[i].num = 0
                }
                this.orderinfo = response.data.msg.marketorder_oneorder
                this.goodslist = response.data.msg.marketorder_oneorder.det
            })
            .catch(error => {
                console.log(error);
            })
        },
        subInfo () { // 提交订单
            this.http.post(api.applyreturngoods,
                {
                    ggids: this.ggids,
                    ordernums: this.ordernums,
                    goodscosts: this.goodscosts,
                    ordergoodscontents: this.ordergoodscontents,
                    is_send: this.issend,
                    is_cxtype: this.cxtype,
                    i_content: this.returnremarks,
                    orderid: this.orderinfo.id,
                    orderdno: this.orderinfo.orderdno,
                }
            )
            .then(response => {
                console.log(response.data.msg)
                this.$Message.success('申请退货成功！')
                setTimeout(() => {
                    this.$router.push({
                        name: '退货单订单详情',
                        params: {
                            id: response.data.msg.orderinfo
                        }
                    })
                }, 0)
            })
            .catch(error => {
                this.$Message.error(error);
            })
        },
        goto (id) { // 跳转详情页
            this.$router.push({
                name: '商品详情',
                params: {
                    id: id
                }
            })
        },
        edit (info, index) { // 编辑备注
            this.remarksShow = true
            this.remarksInfo = info
            this.index = index
        },
        remarksOk (e) { // 修改备注
            this.remarksShow = false
            this.goodslist[this.index].ordergoodscontent = e
        },
        remarksCancel () { // 关闭备注弹窗
            this.remarksShow = false
        },
        minBtn (num, rebacknum, index) { // 点击减号
            if (num > rebacknum) {
                this.goodslist[index].num = num - 1
            } else if (num > 0 && num == rebacknum) {
                this.$Message.warning('退货数为0则表示不退货！')
            } else if (num == 0) {
                this.$Message.warning('退货数为0则表示不退货！')
            }
            this.getreturncost()
        },
        addBtn (num, sendcount, rebacknum, index) { // 点击加号
            (num < (sendcount - rebacknum)) ? this.goodslist[index].num += 1 : this.$Message.warning('可退数为' + (sendcount - rebacknum))
            this.getreturncost()
        },
        numBlur (num, sendcount, rebacknum, index) {
            if (num < (sendcount - rebacknum)) {
                this.goodslist[index].num = num
            } else {
                this.goodslist[index].num = sendcount - rebacknum
                this.$Message.warning('可退数为' + (sendcount - rebacknum))
            }
            this.getreturncost()
        },
        getreturncost () { // 获取退货金额
            var goodslist = this.goodslist
            var cost = 0
            for (var i = 0; i < goodslist.length; i++) {
                if (goodslist[i].is_send == 0) {
                    cost = (parseFloat(cost) + parseInt(goodslist[i].num) * parseFloat(goodslist[i].goodscost)).toFixed(2)
                }
            }
            this.returngoodscost = cost
        },
        confirmbtn () { // 确认按钮
            let sign = -1
            let ggidarr = [] // 商品规格id
            let ordernumarr = [] // 商品数量
            let goodscostarr = [] // 商品单价
            let ordergoodscontentarr = [] // 商品备注
            let issendarr = [] // 是否为赠品
            let cxtypearr = [] // 商品促销

            for (var i = 0; i < this.goodslist.length; i++) {
                if (this.goodslist[i].num > 0) {
                    ggidarr.push(this.goodslist[i].goodsdetid)
                    ordernumarr.push(this.goodslist[i].num)
                    goodscostarr.push(this.goodslist[i].goodscost)
                    ordergoodscontentarr.push(this.goodslist[i].ordergoodscontent)
                    issendarr.push(this.goodslist[i].is_send)
                    cxtypearr.push(this.goodslist[i].cxtype)
                } else {
                    sign = i
                }
            }

            if (sign != this.goodslist.length) {
                this.ggids = ggidarr.join(',')
                this.ordernums = ordernumarr.join(',')
                this.goodscosts = goodscostarr.join(',')
                this.ordergoodscontents = ordergoodscontentarr.join(',')
                this.issend = issendarr.join(',')
                this.cxtype = cxtypearr.join(',')
                this.subInfo()
            } else {
                this.$Message.error('请选择退货商品')
            }
        },
        cancelbtn () { // 取消按钮
            this.$router.push({
                name: '订货详情',
                id: this.$route.params.id
            })
        }
    },
    created () {
        this.getInfo()
    },
    filters: {
        moneyFilter (money) {
            return toMoney(money)
        }
    },
}
</script>

<style scoped>
.returngoods_content {
    padding: 20px;
}

.returngoods_box {
    padding-bottom: 20px;
    border-top: 1px solid #f0f0f0;
}

.returngoods_remarks {
    display: flex;
    flex-direction: row;
    padding-top: 20px;
}

.returngoods_remarks > span {
    flex-grow: 0;
    flex-shrink: 0;
    margin-top: 4px;
    margin-right: 4px;
    font-size: 14px;
    color: #333;
}

.returngoods_btn {
    padding: 20px;
    text-align: center;
    font-size: 0;
}

.returngoods_btn > button {
    min-width: 88px;
    height: 40px;
    margin: 0 6px;
    font-size: 16px;
}

</style>


// WEBPACK FOOTER //
// src/components/views/order/returngoods.vue